import { SUPPORTED_LOCALES } from '../i18n/config';

const CATEGORY_IDS = new Set(['shadow', 'light', 'frontier', 'unclassified']);

/** Public Banquet URL（`/arena/banquet`、言語付きは `/en/arena/banquet` 等。本文は日本語） */
export function banquetPublicPath(locale: string, rest = ''): string {
  const suffix = rest ? `/${rest.replace(/^\/+/, '')}` : '';
  if (locale === 'ja' || locale.startsWith('ja-')) return `/arena/banquet${suffix}`;
  if ((SUPPORTED_LOCALES as readonly string[]).includes(locale)) {
    return `/${locale}/arena/banquet${suffix}`;
  }
  const short = locale.split('-')[0];
  if ((SUPPORTED_LOCALES as readonly string[]).includes(short)) {
    return `/${short}/arena/banquet${suffix}`;
  }
  return `/arena/banquet${suffix}`;
}

export function banquetCategoryPath(locale: string, categoryId: string): string {
  return banquetPublicPath(locale, categoryId);
}

export function banquetFigurePath(locale: string, slug: string): string {
  return banquetPublicPath(locale, slug);
}

export function banquetCanonicalRedirect(pathname: string): string | null {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === '/ja/arena/banquet' || path.startsWith('/ja/arena/banquet/')) {
    return path.replace(/^\/ja/, '') || '/arena/banquet';
  }
  return null;
}

export function isBanquetPublicPath(pathname: string): boolean {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === '/arena/banquet' || path.startsWith('/arena/banquet/')) return true;
  return SUPPORTED_LOCALES.some(
    (loc) => path === `/${loc}/arena/banquet` || path.startsWith(`/${loc}/arena/banquet/`)
  );
}

export function isBanquetCategoryId(value: string): boolean {
  return CATEGORY_IDS.has(value);
}
